import {PatBemModel} from '@/models/patrimonio/patbem/patbem.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';
import { useStore } from '@/store';


class PatBemService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<PatBemModel>>> {
    const gesEscolaId = useStore().getters.getCodigoEscola;
  return api.post<DataSource <PatBemModel>>('/PatBem/RetornoPaginado', 
      {
        rowsPerPage: itensPorPagina,
        pageNumber: pagina,
        filters,
      },
      {
        params: {
          GesEscolaId: gesEscolaId,
        },
      }
  );

 }

 inserirAtualizar(patBem: PatBemModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/PatBem', patBem);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/PatBem/' + id);
 }

 atualizar(patBem: PatBemModel): Promise<AxiosResponse> {
  return api.put('/PatBem', patBem);
 }

 async get(id: number): Promise<PatBemModel> {
  const result = await api.get<PatBemModel>(`/PatBem/${id.toString()}`);
  return result.data;
 }

 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/PatBem/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }
}
export default new PatBemService();
